import getFileExtension from '@framework/data-helpers/string/getFileExtension';
import mapFileExtensionToIcon from '@creditflowresearch/uilib/utils/mapFileExtensionToIcon';
import { mapExtensionToColor } from '@framework/data-helpers/color';
import IconDownload from '@creditflowresearch/uilib/Icon/IconDownload';
import useDownloadAttachment from '@/creditflowresearch/application/ArticlesAndStats/useDownloadAttachment';

import styles from './styles.module.scss';

const StatsAttachment = ({ attachment }: { attachment: { uploadId: string, displayName: string } }) => {
  const { downloadAttachment } = useDownloadAttachment();
  const fileExtention = getFileExtension(attachment.displayName);
  const IconComponent = mapFileExtensionToIcon(fileExtention);
  const color = mapExtensionToColor(fileExtention);

  return (
    <div
      className={ styles.downloadItem }
      data-test="downloadExpandedAttachment"
      onClick={ () => downloadAttachment(attachment) }
    >
      <IconComponent
        style={ { fill: color } }
        className={ styles.downloadItemIcon }
      />
      <p
        className={ styles.downloadItemName }
        data-test="attachmentName"
      >
        { attachment.displayName }
      </p>
      <IconDownload
        data-test="downloadAttachment"
        className={ styles.downloadIcon }
      />
    </div>
  );
};

export default StatsAttachment;
